import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LaravelResourceResponse } from '../../../../../_base-shared/contracts/laravel-response.interface';
import { Product } from '../../../../../_base-shared/models/Product';
import { MainBaseApiService } from '../../_shared/services/main-base-api.service';

@Injectable({
  providedIn: 'root',
})
export class PaymentProcessorService extends MainBaseApiService {
  public index(requestData = {}): Observable<LaravelResourceResponse<Array<Product>>> {
    const params = MainBaseApiService.convertFiltersForRequest(requestData, 'get');
    return this.http.get<LaravelResourceResponse<Array<Product>>>(this.apiUrl + '/payment-processors', {params})
        .pipe(catchError(response => this.handleError(response)));
  }
}
